import { services } from '@octadesk-tech/services'
import { getParameterHeaders } from './headers'

const getClient = () => services.chatAgents.getClient()

const ONLINE_STATUS = 0

export const getGroupAgentsOnlineCount = id =>
  getClient()
    .then(client =>
      client.get(`/${id}/status/${ONLINE_STATUS}/count`, {
        headers: getParameterHeaders()
      })
    )
    .then(response => response.data)
